import { lazy } from "react";

export * from "./MarkdownEditor";

const MdxMarkdownEditor = lazy(() => import("./MdxMarkdownEditor"));

export { MdxMarkdownEditor };
